var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook2 = function SvgFacebook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 12.072a12 12 0 1 0-13.875 11.85V15.54H7.079v-3.468h3.046V9.427a4.234 4.234 0 0 1 4.531-4.668q1.352.018 2.687.234V7.95h-1.512a1.732 1.732 0 0 0-1.95 1.875v2.25h3.328l-.532 3.468h-2.802v8.387A12 12 0 0 0 24 12.072"
  })));
};
export default SvgFacebook2;